
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Відкрити меню браузера`,
's182ab2d6c997515f': `Додайте на Домашній екран для зручного доступу та ширших можливостей.`,
's1b9047d53d9f9d22': `2) Натиснути «Поділитися»`,
's2d90afa5dcca2c0e': `3) Прокрутіть вниз до «На Початковий экран»`,
's37a9e8aec5713460': `Детальніше`,
's4593f304dac8848c': `2) Натиснути «На Початковий экран»`,
's54cfbb14f46396d4': `1) Відкрити у вашому основному браузері`,
's6196153c4b0c1ea0': `Встановити`,
's922329d6f6213590': `Додати на Dock`,
'sa5ef80b4bb9b39f8': `Згорнути`,
'sa7551383d1897fcc': `2) Натиснути «Додати на Dock»`,
'sba52286c21552a4e': `Встановіть на ваш пристрій для зручного доступу та ширших можливостей.`,
'sc79fd7641eb9a975': `Сховати Інструкцію`,
'scdaf4bbff76674c8': `На Початковий экран`,
'se740f75b95a51807': `Додайте на панель Dock для зручного доступу та ширших можливостей.`,
'sfea652f6580ff086': `Цей сайт має функції додатку.`,
    };
  